import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http: HttpClient) { }



  SendEmail(title: string, text: string) {
    return this.http.post(environment.API_url + 'secure-api/v2/email/dev', {
      title,
      text
    });
  }
  // IF
  getReport12MonthsPeriodQuotation() {
    return this.http.get(environment.API_url + 'secure-api/dashboard/getReport12MonthPeriodQuotation')
  }

  getReport7DaysPeriodActiveQuotation() {
    return this.http.get(environment.API_url + 'secure-api/dashboard/getReport7DayPeriodActiveQuotation')
  }

  getReportValueTradedProposal() {
    return this.http.get(environment.API_url + 'secure-api/dashboard/getReportValueTradedProposal')
  }

  getReportProposal() {
    return this.http.get(environment.API_url + 'secure-api/dashboard/getReportProposal')
  }

  // SUPPLIER

  getQuotationByCompany() {
    return this.http.get(environment.API_url + 'secure-api/quotes/getQuotationByCompany')
  }


  getReportActiveProposal(id: string) {
    return this.http.get(environment.API_url + 'secure-api/dashboard/supplier/getReportActiveProposal/' + id)
  }

  getReportProposalSupplier() {
    return this.http.get(environment.API_url + 'secure-api/dashboard/supplier/getReportProposal')
  }

  getReportQuotation() {
    return this.http.get(environment.API_url + 'secure-api/dashboard/supplier/getReportQuotation')
  }

}
